import { PublicationStatus } from "api-client";
import { SearchTabsProps } from "features/ProductSearch/SearchStore";

export const OTHER_PROPERTIES_OPTIONS = [
  {
    id: "is_sentinel",
    name_de: "SHI Gesundheitsgeprüft",
    name: "Certified material health",
    tooltip_de:
      "Bauprodukt enthält mindestens ein EPD mit zusätzlichen Dokumenten, die durch das Sentinel Holding Institut ergänzt wurden.",
    tooltip:
      "Building product contains at least one EPD with additional documents supplemented by the Sentinel Holding Institute.",
  },
];

export const REFERENCE_UNITS = [
  { id: "PCS", name: "Pieces", name_de: "Stück" },
  { id: "M", name: "m", name_de: "m" },
  { id: "M2", name: "m²", name_de: "m²" },
  { id: "M3", name: "m³", name_de: "m³" },
  { id: "KG", name: "kg", name_de: "kg" },
];

export const PRODUCT_PUBLICATION_STATUS = [
  {
    id: PublicationStatus.Published,
    name: "Published",
    name_de: "Veröffentlicht",
  },
  {
    id: PublicationStatus.Unpublished,
    name: "Offline",
    name_de: "Offline",
  },
];

export const NO_OBJECT_DATA_DOCS_URL =
  "https://docs.circularlca.de/Werden-bestimmte-IFC-Entit-ten-beim-Import-vom-System-ignoriert-a14fcb3ea9564e09967115016f18f2c0";

export const FIELDSSET_TITLE_CLASSES =
  "text-base font-semibold mb-3 text-gray-900";
export const FIELD_LABEL_CLASSES = "text-sm font-medium mb-1 text-gray-600";
export const FIELD_VALUE_CLASSES =
  "flex text-sm font-normal pb-4 text-gray-500";

export const SEARCH_TABS_LIST: SearchTabsProps[] = [
  {
    id: "used_products",
    type: undefined,
    source: undefined,
  },
  {
    id: "concular_products",
    type: "PRODUCT",
    source: undefined,
  },
  {
    id: "custom_products",
    type: "PRODUCT",
    source: "custom",
  },
  {
    id: "concular_components",
    type: "COMPONENT",
    source: undefined,
  },
  {
    id: "custom_components",
    type: "COMPONENT",
    source: "custom",
  },
];

export const ORGANIZATIONAL_SEARCH_TABS_LIST: SearchTabsProps[] = [
  {
    id: "used_products",
    type: undefined,
    source: undefined,
  },
  {
    id: "custom_products",
    type: "PRODUCT",
    source: "custom",
  },
  {
    id: "custom_components",
    type: "COMPONENT",
    source: "custom",
  },
  {
    id: "concular_products",
    type: "PRODUCT",
    source: undefined,
    hidden: false,
  },
  {
    id: "concular_components",
    type: "COMPONENT",
    source: undefined,
    hidden: false,
  },
];

export const COMPONENT_DATA_LOCAL_KEY = "tempt_component_data";

export const XKT_FILE_STATUS = {
  IDLE: "IDLE",
  PROCESSING: "PROCESSING",
  FAILED: "FAILED",
  DONE: "DONE",
};

export const DME_HELP_URL =
  "https://docs.circularlca.de/Wie-kann-ich-Produktverkn-pfungen-im-Mapping-Editor-durchf-hren-8951b61aef2f4a4c965f9ba22e60521a";
